import parseDecimal from "./parseDecimal";

export default function calculateTotalCostOfCredit(
  vehiclePrice,
  rate,
  deposit,
  balloon,
  period
) {
  const initiationFee = 1207.5;
  const ratePercent = rate / 100;
  console.log("🚀 ~ ratePercent:", ratePercent)
  // const depositPercent = deposit / 100;
  // console.log("🚀 ~ depositPercent:", depositPercent)
  const balloonPercent = balloon / 100;
  console.log("🚀 ~ balloonPercent:", balloonPercent)
  // const depositAmount = vehiclePrice * depositPercent;
  // console.log("🚀 ~ depositAmount:", depositAmount)
  const fees = 69;

  //const financeAmount = B28 + B29 - (B30 * B28)
  const financeAmount = vehiclePrice + initiationFee - deposit;
  console.log('financeAmount', financeAmount);

  // const financeAmountWithBalloon = B28+B29-(B30*B28)-(B33*B28)
  const financeAmountWithBalloon = vehiclePrice + initiationFee - deposit - (vehiclePrice * balloonPercent);
  console.log('financeAmountWithBalloon', financeAmountWithBalloon);

  // const monthlyPayment = (((301207.50 * (1 + 0.13 / 12) ^ 12) - (301207.50 - 248707.50)) / (((1 + 0.13 / 12) ^ 12) - 1)) * 0.13 / 12;
  const monthlyPayment = (((financeAmount * Math.pow((1 + ratePercent / 12), period)) - (financeAmount - financeAmountWithBalloon)) / ((Math.pow((1 + ratePercent / 12), period)) - 1)) * ratePercent / 12;
  console.log('monthlyPayment:', monthlyPayment);

  const totalRepayment = monthlyPayment + fees;
  console.log('totalRepayment', totalRepayment);

  // const totalCostOfCredit = F50*B32+(F29-F28)
  const totalCostOfCredit = totalRepayment * period + (financeAmount - financeAmountWithBalloon);
  console.log('totalCostOfCredit', totalCostOfCredit);

  return parseDecimal(totalCostOfCredit);
}
